














































































import FilterCard from "@/components/filter/FilterCard.vue";
import ViewedPreview from "@/components/utility/ViewedPreview.vue";
import { simpleDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { TimeStampEntity } from "@/models/timestampEntity";
import { IPartnerMessage } from "@/models/partner-message.entity";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import TheLayoutPortalList from "../../layouts/TheLayoutPortalList.vue";
import TemplateDialog from "../template/TemplateDialog.vue";
import Tooltip from "../utility/tooltip.vue";
import { PaginatedBaseStore } from "@/store/paginated-base.store";
import { avatar } from "@/lib/utility/mail-helper";
import { MrfiktivInboxDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { copyToClipboard } from "@/lib/utility/copy-to-clipboard.helper";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";
import { UserModule } from "@/store/modules/me-user.store";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";

@Component({
  components: {
    ViewedPreview,
    FilterCard,
    Tooltip,
    TheLayoutPortalList,
    TemplateDialog
  }
})
export default class PartnerMessageListPaginated extends mixins(
  DarkModeHighlightMixin,
  PartnerFallbackMixin,
  PermissionMixin
) {
  @Prop({ default: false })
  loading!: boolean;

  @Prop({
    default: "components.PartnerMessageListPaginated.title"
  })
  title!: string;

  @Prop({})
  inbox!: MrfiktivInboxDtoGen;

  @Prop({})
  store!: PaginatedBaseStore<any, any>;

  @Prop()
  selected?: IPartnerMessage;

  isLoadingMore = false;

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return PartnerModule.partner.id;
  }

  get quickFilters(): PredefinedFilterType[] {
    const quickFilters: PredefinedFilterType[] = [];

    quickFilters.push({
      name: "project.ticket.mine",
      filter: [
        new PageFilterElement({
          key: "assignees",
          value: UserModule.userId,
          operation: PageFilterOperationEnum.EQUAL
        })
      ]
    });

    quickFilters.push({
      name: "components.PartnerMessageDetail.isNotRead",
      filter: [
        new PageFilterElement({
          key: "isRead",
          operation: PageFilterOperationEnum.EQUAL,
          value: false as any
        })
      ]
    });

    return quickFilters;
  }

  displayName(item: IPartnerMessage): string {
    if (item.folder === "outbox") {
      return item.to;
    }

    if (item.from) {
      return item.from;
    }

    return "";
  }

  avatar(item: IPartnerMessage): string {
    const mail = this.displayName(item);

    return avatar(mail);
  }

  getModule() {
    return this.store;
  }

  async set(item: IPartnerMessage) {
    this.$emit("set", item);
  }

  async refresh() {
    this.loading = true;

    try {
      await this.store.fetchFirstPage({
        partnerId: PartnerModule.partner._id
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  async loadMore() {
    try {
      this.isLoadingMore = true;
      await this.store.fetchNextPage({
        partnerId: PartnerModule.partner._id
      });
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoadingMore = false;
    }
  }

  /**
   * Some methods for the presentation of items in the list
   */
  itemFunctions = {
    content: (item: IPartnerMessage) => {
      return item.preview;
    },
    date: (item: IPartnerMessage) => {
      return simpleDate((item.timestamp as TimeStampEntity).created);
    }
  };

  copyToClipboard(value: string) {
    copyToClipboard(value);
  }
}
